import React from "react";
import { Link } from "react-router-dom";
import { FaChevronDown } from "react-icons/fa";
import RoleStatusBadge from "./RoleStatusBadge";
import { elakayAutoText } from "../../pageInside/dataElakay";


// Real per-category collapsible accordion (redesign ticket §6/§7) -- replaces the old flat
// "render every group's chips at once" list. Accessible by construction: each header is a real
// <button> with aria-expanded/aria-controls, never a non-accessible div (ticket §7 explicit
// requirement). Only one category open at a time by default (ticket §7's stated preference),
// controlled by the parent (expandedGroupKey/onToggleGroup) so "Explore Services" can also drive
// it (open + scroll to the first group) without duplicating state here.
const RoleServiceAccordion = ({
  plan,
  groups,
  allSettings,
  getGroupLabel,
  getChipText,
  expandedGroupKey,
  onToggleGroup,
  containerId,
}) => (
  <div className="userstep-service-accordion" id={containerId}>
    {(groups || []).map((group) => {
      const isOpen = expandedGroupKey === group.key;
      const headerId = `${containerId}-header-${group.key}`;
      const panelId = `${containerId}-panel-${group.key}`;
      const itemCount = (group.items || []).length;

      return (
        <div key={group.key} className={`userstep-service-group${isOpen ? " userstep-service-group--open" : ""}`}>
          <h4 className="userstep-service-group-heading">
            <button
              type="button"
              id={headerId}
              className="userstep-service-group-toggle"
              aria-expanded={isOpen}
              aria-controls={panelId}
              onClick={() => onToggleGroup(group.key)}
            >
              <span className="userstep-service-group-label">{getGroupLabel(group)}</span>
              <span className="userstep-service-group-meta">
                <span className="userstep-service-group-count">{elakayAutoText(itemCount === 1 ? "serviceCountOne" : "serviceCountMany", itemCount === 1 ? "{value0} service" : "{value0} services", { value0: itemCount })}</span>
                <RoleStatusBadge group={group} plan={plan} allSettings={allSettings} />
                <FaChevronDown className="userstep-service-group-chevron" aria-hidden="true" />
              </span>
            </button>
          </h4>
          <div
            id={panelId}
            role="region"
            aria-labelledby={headerId}
            className="userstep-service-group-panel"
            hidden={!isOpen}
          >
            <div className="userstep-plan-group-chips">
              {(group.items || []).map((item) =>
                item.route ? (
                  <Link key={item.key} to={item.route} className="userstep-chip userstep-chip--link">
                    {getChipText(item)}
                  </Link>
                ) : (
                  <span key={item.key} className="userstep-chip">
                    {getChipText(item)}
                  </span>
                )
              )}
            </div>
          </div>
        </div>
      );
    })}
  </div>
);

export default RoleServiceAccordion;
